import BaseController from "@/attributes/BaseController";
import InitThirdAppService from "../service/InitThirdAppService";

class ThirdAppController extends BaseController {
  // constructor() {
  //     super();
  // }
  listDBService: any;
  initDb() {
    this.listDBService = InitThirdAppService.GetListService();
  }
  specialOnlineMethod(dbName: any, data: any) {
    const group = InitThirdAppService.group;
    let result = data;
    if (!group || group?.version !== result.version) {
      result.groupApplications = result.groupApplications.map((item: any) => {
        return item.applications
          ? item
          : group?.groupApplications.find((_item: any) => _item.groupId === item.groupId);
      });
    } else {
      result = group?.groupApplications ? group : result;
    }
    return result;
  }
  setGroupApplications(propertyKey: string, data: any, ...args: any[]) {
    const _propertyKey = `${propertyKey}`;
    return this.listDBService.setDBList(_propertyKey, data);
  }
  getGroupApplications(propertyKey: string) {
    const _propertyKey = `${propertyKey}`;
    return this.listDBService.getDBList(_propertyKey);
  }
}

export default new ThirdAppController();
